import {useCallback, useEffect, useState} from 'react';
import {DoughnutChart, DataHasilCard, RightDropdown} from '../../../components';
import {Language} from '../../../context/LanguageContext';
import axios from 'axios';
import {APIURL} from '../../../consts';
import Cookies from 'js-cookie';
import {IconCloseFullScreen, IconOpenFullScreen} from '../../../assets';
import '../../../assets/styles/dataHasil.scss';
import {Button} from '@mui/material';
import {numberWithCommas} from '../../../Helpers/stringFormat';
export default function DataHasil({
  zoomer,
  projectCode,
  pkCode,
  negeriCode,
  wilayahCode,
  mapRef,
}) {
  // console.log(zoomer, 'zoomer');
  const [payload, setPayload] = useState({
    jenisTanaman: {label: 'Sawit', value: 'Sawit'},
    historical: {label: 'Hari ini', value: 'Hari ini'},
    status: {label: 'Semua', value: 'Semua'},
    comp_type: 'all',
  });
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [data, setData] = useState();
  const {newObj, language} = Language();
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    responsiveAnimationDuration: 0,
    aspectRatio: 1,
    width: '100%',
    plugins: {
      legend: {
        display: false, // set this to false to hide the legend
      },
    },
  };
  const handleZoomLevel = useCallback(
    (zoom) => {
      // console.log(zoom, 'zoom');
      if (zoom >= 14) {
        return {
          level: 'projek',
          kod: projectCode,
        };
      } else if (zoom >= 12) {
        return {level: 'kawasan', kod: pkCode ? pkCode : '', title: 'PK Name'};
      } else if (zoom >= 10) {
        return {
          level: 'negeri',
          kod: negeriCode ? negeriCode : '',
          title: 'Negeri Name',
        };
      } else if (zoom >= 8) {
        return {
          level: 'wilayah',
          kod: wilayahCode ? wilayahCode : '',
          title: 'Wilayah Name',
        };
      } else {
        return {level: 'all', kod: 'all', title: 'Nasional'};
      }
    },
    [projectCode, pkCode, negeriCode, wilayahCode, zoomer]
  );

  const downloadReport = useCallback(async () => {
    try {
      const zoomLevel = handleZoomLevel(zoomer);
      const response = await axios.get(APIURL.download_report_data_hasil, {
        params: {
          level: zoomLevel.level,
          kod: zoomLevel.kod,
          jenisTanaman: payload.jenisTanaman.value.toUpperCase(),
          historical: payload.historical.value
            .split(' ')
            .join('_')
            .toUpperCase(),
          comp_type: payload.comp_type.toUpperCase(),
        },
        headers: {
          Authorization: `Bearer ${Cookies.get('token')}`,
        },
        responseType: 'blob', // Set response type to blob for file download
      });
      // console.log(response, 'response');
      const blob = new Blob([response.data], {
        type: 'application/vnd.ms-excel',
      });
      const filename =
        response.headers['content-disposition'].split('filename=')[1];
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log(error);
    }
  }, [zoomer, payload, projectCode, pkCode, negeriCode, wilayahCode]);

  const getData = useCallback(
    async (payload) => {
      const zoomLevel = handleZoomLevel(zoomer);
      const formData = new FormData();
      formData.append('jenisTanaman', payload.jenisTanaman.value);
      formData.append('historical', payload.historical.value);
      formData.append('status', payload.status.value);
      formData.append('comp_type', payload.comp_type);
      formData.append('level', zoomLevel.level);
      formData.append('kod', zoomLevel.kod);
      formData.append('latitude_x', mapRef.current.getBounds()._southWest.lat);
      formData.append('longitude_x', mapRef.current.getBounds()._southWest.lng);
      formData.append('latitude_y', mapRef.current.getBounds()._northEast.lat);
      formData.append('longitude_y', mapRef.current.getBounds()._northEast.lng);
      formData.append('center_lat', mapRef.current.getBounds().getCenter().lat);
      formData.append(
        'center_long',
        mapRef.current.getBounds().getCenter().lng
      );
      formData.append('flag', zoomLevel.kod ? 'click' : 'drag');
      formData.append('publish_status', 'publish');
      if (
        zoomLevel.level !== 'projek' ||
        (zoomLevel.level === 'projek' && zoomLevel.kod)
      ) {
        const response = await axios.post(APIURL.map_data_hasil_get, formData, {
          headers: {
            Authorization: `Bearer ${Cookies.get('token')}`,
          },
        });
        const {data} = response;
        setData(data);
      }
    },
    [
      payload,
      zoomer,
      projectCode,
      pkCode,
      negeriCode,
      wilayahCode,
      isFullScreen,
    ]
  );

  const handleChartData = useCallback(
    (persen = 100) => {
      if (persen < 100) {
        let obj = {
          data: persen === 0 ? [0, 0] : [persen, 100 - persen],
        };
        if (persen < 79) {
          obj.backgroundColor = ['#E21F26', '#ffffff'];
          obj.gradientBackgroundColor =
            'linear-gradient(324.48deg, #2B337D -2.36%, #E21F26 100.51%)';
        } else {
          obj.backgroundColor = ['#FFA801', '#ffffff'];
          obj.gradientBackgroundColor =
            'linear-gradient(326.32deg, #2B337D -7.58%, #FFA801 127.34%)';
        }
        return obj;
      } else if (persen >= 100) {
        return {
          data: [persen, 0],
          backgroundColor: ['#00A550', '#00A550'],
          gradientBackgroundColor:
            'linear-gradient(330.79deg, #2B337D -17.89%, #00A550 77.87%)',
        };
      }
    },
    [data]
  );
  const handleViewFullScreen = useCallback(() => {
    if (!isFullScreen) {
      if (payload.jenisTanaman.value === 'Sawit')
        return (
          <div className='data_list'>
            <div className='data_item'>
              <p>Backlog (MT)</p>
              <p className='text'>{data?.data?.card?.backLog}</p>
            </div>
            <div className='data_item'>
              <p>Mandays</p>
              <p className='text'>{data?.data?.card?.mandays}</p>
            </div>
            <div className='data_item'>
              <p>% Kehadiran Penuai</p>
              <p className='text'>
                {numberWithCommas(
                  data?.data?.card?.persen_kehadiran_penuai?.toFixed(2)
                )}
                %
              </p>
            </div>
          </div>
        );
      else
        return (
          <div className='data_list'>
            <div className='data_item'>
              <p>Bil. Penoreh H.I</p>
              <p className='text'>{data?.data?.card?.bil_penoreh_hi}</p>
            </div>
            <div className='data_item'>
              <p>Bil. Penoreh Sepatut</p>
              <p className='text'>{data?.data?.card?.bil_penoreh_sepatut}</p>
            </div>
            <div className='data_item'>
              <p>Bil. Penoreh Sedia Ada</p>
              <p className='text'>{data?.data?.card?.bil_penoreh_sedia_ada}</p>
            </div>
          </div>
        );
    } else {
      if (payload.jenisTanaman.value === 'Sawit')
        return (
          <>
            <div className='data_list'>
              <div className='data_item'>
                <p>Backlog (MT)</p>
                <p className='text'>{data?.data?.card?.backLog}</p>
              </div>
            </div>
            <hr />
            <div className='data_list'>
              {/* <div className='data_item'>
              <p>Bilangan Projek</p>
              <p className='text'>{data?.data?.card?.bilangan_projek}</p>
            </div> */}
              <div className='data_item'>
                <p>Luas Tanam (HEK)</p>
                <p className='text'>{data?.data?.card?.luas_tanam_hek}</p>
              </div>
              <div className='data_item'>
                <p>Luas Hasil (HEK)</p>
                <p className='text'>{data?.data?.card?.luas_hasil_hek}</p>
              </div>
            </div>
            <hr />
            <div className='data_list'>
              <div className='data_item'>
                <p>Bil Penuai Sepatut</p>
                <p className='text'>{data?.data?.card?.bil_penuai_sepatut}</p>
              </div>
              <div className='data_item'>
                <p>Bil Penuai Sedia Ada</p>
                <p className='text'>{data?.data?.card?.bil_penuai_sedia_ada}</p>
              </div>
              <div className='data_item'>
                <p>Bil Penuai Hadir</p>
                <p className='text'>{data?.data?.card?.bil_penuai_hadir}</p>
              </div>
              <div className='data_item'>
                <p>% Kehadiran Penuai</p>
                <p className='text'>
                  {numberWithCommas(
                    data?.data?.card?.persen_kehadiran_penuai?.toFixed(2)
                  )}
                  %
                </p>
              </div>
              <div className='data_item'>
                <p>Mandays</p>
                <p className='text'>{data?.data?.card?.mandays}</p>
              </div>
            </div>
            <hr />
            <div className='data_list'>
              <div className='data_item'>
                <p>% OER</p>
                <p className='text'>{data?.data?.card?.persen_oer}</p>
              </div>
              <div className='data_item'>
                <p>Bilangan Tandan</p>
                <p className='text'>{data?.data?.card?.bilangan_tandan}</p>
              </div>
              <div className='data_item'>
                <p>Purata Berat Tandan</p>
                <p className='text'>{data?.data?.card?.purata_berat_tandan}</p>
              </div>
            </div>
            <Button className='data_download' onClick={() => downloadReport()}>
              {newObj.DownloadResultsReportWord[language]}
            </Button>
          </>
        );
      else
        return (
          <>
            <div className='data_list'>
              <div className='data_item'>
                <p>Bil Penoreh Sepatut</p>
                <p className='text'>{data?.data?.card?.bil_penoreh_sepatut}</p>
              </div>
              <div className='data_item'>
                <p>Bil Penoreh Sedia Ada</p>
                <p className='text'>
                  {data?.data?.card?.bil_penoreh_sedia_ada}
                </p>
              </div>
              <div className='data_item'>
                <p>Bil Penoreh Hadir</p>
                <p className='text'>{data?.data?.card?.bil_penoreh_hi}</p>
              </div>
              <div className='data_item'>
                <p>% Kehadiran Penoreh</p>
                <p className='text'>
                  {numberWithCommas(
                    data?.data?.card?.persen_kehadiran_penoreh?.toFixed(2)
                  )}
                  %
                </p>
              </div>
              {/* <div className='data_item'>
                <p>Mandays</p>
                <p className='text'>{data?.data?.card?.mandays}</p>
              </div> */}
            </div>
            <hr />
            <div className='data_list'>
              <div className='data_item'>
                <p>Timb. Ladang (KG Basah)</p>
                <p className='text'>
                  {data?.data?.card?.timbangan_ladang_kg_basah}
                </p>
              </div>
              <div className='data_item'>
                <p>Timb. Kilang (KG Basah)</p>
                <p className='text'>
                  {data?.data?.card?.timbangan_kilang_kg_basah}
                </p>
              </div>
              <div className='data_item'>
                <p>Timb. Kilang (KG Kering)</p>
                <p className='text'>
                  {data?.data?.card?.timbangan_kilang_kg_kering}
                </p>
              </div>
              <div className='data_item'>
                <p>Beza Susutan Berat (KG Basah)</p>
                <p className='text'>
                  {data?.data?.card?.beza_susutan_berat_kg_basah}
                </p>
              </div>
              <div className='data_item'>
                <p>% Susutan Berat</p>
                <p className='text'>
                  {numberWithCommas(
                    data?.data?.card?.persen_susutan_berat?.toFixed(2)
                  )}{' '}
                  %
                </p>
              </div>
              <div className='data_item'>
                <p>% DRC</p>
                <p className='text'>
                  {numberWithCommas(data?.data?.card?.persen_drc?.toFixed(2))} %
                </p>
              </div>
              <div className='data_item'>
                <p>% Capai</p>
                <p className='text'>
                  {numberWithCommas(data?.data?.card?.persen_capai)} %
                </p>
              </div>
            </div>
            <hr />
            <div className='data_list'>
              <div className='data_item'>
                <p>Jumlah Task Hilang</p>
                <p className='text'>{data?.data?.card?.jumlah_task_hilang}</p>
              </div>
              <div className='data_item'>
                <p>Jumlah Task Hilang Sebenar</p>
                <p className='text'>
                  {data?.data?.card?.jumlah_task_hilang_sebenar}
                </p>
              </div>
              <div className='data_item'>
                <p>Jumlah Task Toreh Sebenar</p>
                <p className='text'>
                  {data?.data?.card?.jumlah_task_toreh_sebenar}
                </p>
              </div>
              <div className='data_item'>
                <p>% Task Hilang Penoreh</p>
                <p className='text'>
                  {numberWithCommas(
                    data?.data?.card?.persen_task_hilang_penoreh?.toFixed(2)
                  )}{' '}
                  %
                </p>
              </div>
              <div className='data_item'>
                <p>% Task Hilang Hujan</p>
                <p className='text'>
                  {numberWithCommas(
                    data?.data?.card?.persen_task_hilang_hujan?.toFixed(2)
                  )}{' '}
                  %
                </p>
              </div>
              <div className='data_item'>
                <p>% Task Hilang Total</p>
                <p className='text'>
                  {numberWithCommas(
                    data?.data?.card?.persen_task_hilang_total?.toFixed(2)
                  )}{' '}
                  %
                </p>
              </div>
              <div className='data_item'>
                <p>% Task Toreh Ganti</p>
                <p className='text'>
                  {numberWithCommas(
                    data?.data?.card?.persen_task_toreh_ganti?.toFixed(2)
                  )}{' '}
                  %
                </p>
              </div>
            </div>
            <Button className='data_download' onClick={() => downloadReport()}>
              {newObj.DownloadResultsReportWord[language]}
            </Button>
          </>
        );
    }
  }, [isFullScreen, data, payload.jenisTanaman]);

  const handleViewTableFullScreen = useCallback(() => {
    if (payload.jenisTanaman.value === 'Sawit')
      return (
        <table>
          <thead>
            <tr>
              <th></th>
              <th>MT</th>
              <th>MT/HEK</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Anggaran H.I (SPTT)</td>
              <td>
                {numberWithCommas(
                  data?.data?.card?.anggaran_hi_sptt?.value?.toFixed(2)
                )}
              </td>
              <td>
                {numberWithCommas(
                  data?.data?.card?.anggaran_hi_sptt?.per_hek?.toFixed(2)
                )}
              </td>
            </tr>
            <tr>
              <td>Kuantiti Tuai H.I</td>
              <td>
                {numberWithCommas(
                  data?.data?.card?.kuantiti_tuai_hi?.value?.toFixed(2)
                )}
              </td>
              <td>
                {numberWithCommas(
                  data?.data?.card?.kuantiti_tuai_hi?.per_hek?.toFixed(2)
                )}
              </td>
            </tr>
            <tr>
              <td>Hasil H.I (Capai)</td>
              <td>
                {numberWithCommas(
                  data?.data?.card?.hasil_hi_capai?.value?.toFixed(2)
                )}
              </td>
              <td>
                {numberWithCommas(
                  data?.data?.card?.hasil_hi_capai?.per_hek?.toFixed(2)
                )}
              </td>
            </tr>
          </tbody>
        </table>
      );
    else
      return (
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Task</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Task Patut Ada H.I</td>
              <td>{data?.data?.card?.task_patut_ada_hi}</td>
            </tr>
            <tr>
              <td>Task Toreh H.I</td>
              <td>{data?.data?.card?.task_toreh_hi}</td>
            </tr>
            <tr>
              <td>Task Ganti H.I</td>
              <td>{data?.data?.card?.task_ganti_hi}</td>
            </tr>
            <tr>
              <td>Task Toreh Sebenar H.I</td>
              <td>{data?.data?.card?.task_toreh_sebenar_hi}</td>
            </tr>
          </tbody>
        </table>
      );
  }, [data, payload.jenisTanaman, isFullScreen]);
  useEffect(() => {
    getData(payload);
  }, [zoomer, payload]);

  return (
    <div className='dh_ctr'>
      <div className='dh_data_ctr'>
        <div className='dh_filter'>
          <div className='dh_toggle' style={{background: 'none'}}>
            <div className='dh_toggle_item' style={{padding: '0'}}>
              <RightDropdown
                selectedMenu={payload.jenisTanaman}
                bgColor={'#2b337d'}
                color={'#fff'}
                onClick={(item) =>
                  setPayload((prev) => ({...prev, jenisTanaman: item}))
                }
                menu_list={[
                  {label: 'Sawit', value: 'Sawit'},
                  {label: 'Getah', value: 'Getah'},
                ]}
              />
            </div>
            <div className='dh_toggle_item' style={{padding: '0'}}>
              <RightDropdown
                selectedMenu={payload.historical}
                bgColor={'#2b337d'}
                onClick={(item) =>
                  setPayload((prev) => ({...prev, historical: item}))
                }
                color={'#fff'}
                menu_list={[
                  {label: 'Tahunan', value: 'Tahunan'},
                  {label: 'Bulanan', value: 'Bulanan'},
                  {label: 'Mingguan', value: 'Mingguan'},
                  {label: 'Hari ini', value: 'Hari ini'},
                ]}
              />
            </div>
            <div className='dh_toggle_item' style={{padding: '0'}}>
              <RightDropdown
                selectedMenu={payload.status}
                bgColor={'#2b337d'}
                onClick={(item) =>
                  setPayload((prev) => ({...prev, status: item}))
                }
                color={'#fff'}
                menu_list={[
                  {label: 'Semua', value: 'Semua'},
                  {label: 'Aktif', value: 'Aktif'},
                  {label: 'Tidak Aktif', value: 'Tidak Aktif'},
                ]}
              />
            </div>
          </div>
        </div>
        <p className='dh_title'>
          PENCAPAIAN {payload.historical.label?.toUpperCase()}{' '}
          {handleZoomLevel(zoomer)?.title?.toUpperCase()}
          <br />
          <span>SASARAN {payload.historical.label?.toUpperCase()}</span>
        </p>
        <div
          className='dh_doughnut'
          style={{
            background: handleChartData(data?.data?.card?.persen)
              .gradientBackgroundColor,
          }}
        >
          <div className='dh_card_filter'>
            <div className='dh_tabs'>
              <div
                className={`dh_tab_item ${
                  payload.comp_type === 'all' ? 'active' : ''
                }`}
                onClick={() =>
                  setPayload((prev) => ({...prev, comp_type: 'all'}))
                }
              >
                ALL
              </div>
              <div
                className={`dh_tab_item  ${
                  payload.comp_type === 'pnp' ? 'active' : ''
                }`}
                onClick={() =>
                  setPayload((prev) => ({...prev, comp_type: 'pnp'}))
                }
              >
                P&P
              </div>
              <div
                className={`dh_tab_item  ${
                  payload.comp_type === 'estet' ? 'active' : ''
                }`}
                onClick={() =>
                  setPayload((prev) => ({...prev, comp_type: 'estet'}))
                }
              >
                ESTET
              </div>
            </div>
            <div
              className='dh_fullscreen_icon'
              onClick={() => setIsFullScreen((prev) => !prev)}
            >
              <img
                src={!isFullScreen ? IconOpenFullScreen : IconCloseFullScreen}
                alt='fullscreen_icon'
              />
            </div>
          </div>
          <div className='doughnut_ctr'>
            <div className='doughnut_box'>
              <div className='doughnut_wrapper'>
                <DoughnutChart
                  data={{
                    labels: ['Untung', 'Rugi'],
                    datasets: [
                      {
                        label: 'Persen %',
                        data: handleChartData(data?.data?.card?.persen).data,
                        backgroundColor: handleChartData(
                          data?.data?.card?.persen
                        ).backgroundColor,
                        hoverBackgroundColor: handleChartData(
                          data?.data?.card?.persen
                        ).backgroundColor,
                        borderColor: handleChartData(data?.data?.card?.persen)
                          .backgroundColor,
                        borderWidth: 1,
                      },
                    ],
                  }}
                  options={options}
                />
              </div>
              <div className='doughnut_data'>{handleViewTableFullScreen()}</div>
            </div>
            <hr />
            {handleViewFullScreen()}
          </div>
        </div>
        {/* <div
          className='dh_untung_semasa'
          style={{
            background: handleChartData(data?.data?.header?.pencapaian)
              .backgroundColor[0],
          }}
        >
          <p>Untung Semasa</p>
          <p>RM 1000</p>
        </div> */}
        <hr />
        <div className='dh_title'>
          RANKING HASIL (MT/HA) {handleZoomLevel(zoomer)?.title?.toUpperCase()}
        </div>
        <div className='dh_card_list'>
          {data?.data?.ranking?.map((item, index) => (
            <DataHasilCard
              type={1}
              rank={item.rank}
              title={item.name}
              percentage={item.persen}
              mtValue={item.hasil}
              mtHekValue={item.hasilHek}
              untungSemasa={item.untungSemasa}
              blok={item.blok}
            />
          ))}
        </div>
        <hr />
        <div className='dh_title'>TOP 5 Pejabat Kawasan</div>
        <div className='dh_card_list'>
          {data?.data?.top5_kawasan?.map((item, index) => (
            <DataHasilCard
              type={2}
              rank={item.rank}
              title={item.name}
              percentage={item.persen}
              mtValue={item.hasil}
              mtHekValue={item.hasilHek}
              untungSemasa={item.untungSemasa}
              blok={item.blok}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
